/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as Msdyn365 from '@msdyn365-commerce/core';
import { Address } from '@msdyn365-commerce/retail-proxy';

/**
 * GetCustomerAddress Input Action
 */

export class GetCustomerAddressInput implements Msdyn365.IActionInput {
    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `customerAddress`;
    public getCacheObjectType = () => 'customerAddress';
    public dataCacheType = (): Msdyn365.CacheType => 'request';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetCustomerAddressData {
    addresses: Address[] | undefined;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetCustomerAddressInput();
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(input: GetCustomerAddressInput, ctx: Msdyn365.IActionContext): Promise<IGetCustomerAddressData> {
    return { addresses: undefined };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetCustomerAddressData>>action,
    id: 'GetCustomerAddress',
    input: createInput
});
